import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import cn from 'classnames';
import { createStructuredSelector } from 'reselect';
import DatePicker from 'react-datepicker';

import dayjs from 'dayjs';
import { parseISO } from 'date-fns';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { HBox, VBox } from '../../../components/Box';
import { VehiclePropertyLoadable } from './VehiclePropertyLoadable';
import { setVehicleProperty } from '../actions';
import { COLOR_PRIMARY_1 } from '../../../vars';
import { getPropByName } from '../../../utils/props';

import styles from './VehicleEditableField.module.css';
import { Calendar } from '../../../components/Icon';
import { SearchSelect } from '../../../components/SearchSelectComponent';

dayjs.extend(customParseFormat);

const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 6px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

const DropdownWrapper = styled.div`
  .basic-multi-select {
    width: 100%;
    max-width: 100%;
  }
`;

const STATE = {
  sort: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleEditableFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.setState({
      [this.props.name]: getPropByName(this.props.vehicle, this.props.name),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle != this.props.vehicle) {
      this.setState({
        [this.props.name]: getPropByName(this.props.vehicle, this.props.name),
      });
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  renderEditableVehicleField(name, inputType) {
    let ISO;
    if (inputType == 'date') {
      let date = this.state[name];
      try {
        ISO = date ? parseISO(dayjs(date, 'DD-MM-YYYY').format('YYYY-MM-DD')) : null;
        if (ISO == 'Invalid Date') ISO = null;
      } catch (error) {
        debugger;
      }
    }

    if (inputType == 'dropdown') {
      return (
        <VBox key={name} vCenter gap={'8px'}>
          {this.lbl(`vehicle.property.${name}`)}
          <VehiclePropertyLoadable name={name}>
            <HBox>
              <DropdownWrapper>
                <SearchSelect
                  type={name}
                  options={this.props.options}
                  value={{ label: this.state[name] }}
                  onChange={evt => {
                    this.setState({ [name]: evt.value });
                  }}
                  name={name}
                  key={name}
                  onBlur={() => {
                    this.state[name] && this.props.setProperty(name, this.state[name]);
                    console.log('onBlur', this.state[name]);
                  }}
                />
              </DropdownWrapper>
            </HBox>
          </VehiclePropertyLoadable>
        </VBox>
      );
    }

    if (inputType == 'date') {
      return (
        <VBox key={name} vCenter gap={'8px'}>
          {this.lbl(`vehicle.property.${name}`)}
          <VehiclePropertyLoadable name={name}>
            <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
              <DatePicker
                className={styles.datePicker}
                dateFormat="dd-MM-yyyy"
                selected={this.state[name] ? ISO : ''}
                onChange={val => {
                  val = dayjs(val).format('DD-MM-YYYY');
                  this.props.setProperty(name, val);
                }}
              />
              <Calendar className={styles.iconCalendar} />
            </div>
          </VehiclePropertyLoadable>
        </VBox>
      );
    }
    if (inputType == 'textarea') {
      return (
        <VBox key={name} vCenter gap={'8px'}>
          {this.lbl(`vehicle.property.${name}`)}
          <VehiclePropertyLoadable name={name}>
            <HBox>
              <textarea
                style={{
                  width: '100%',
                }}
                className="form-control"
                type={name}
                value={this.state[name]}
                onChange={this.onInputChange.bind(this)}
                name={name}
                key={name}
                onBlur={() => {
                  this.state[name] && this.props.setProperty(name, this.state[name]);
                  console.log('onBlur', this.state[name]);
                }}
              />
            </HBox>
          </VehiclePropertyLoadable>
        </VBox>
      );
    }
    return (
      <VBox key={name} vCenter gap={'8px'}>
        {this.lbl(`vehicle.property.${name}`)}
        <VehiclePropertyLoadable name={name}>
          <input
            className="form-control"
            type={name}
            value={this.state[name]}
            onChange={this.onInputChange.bind(this)}
            name={name}
            key={name}
            onBlur={() => {
              this.state[name] && this.props.setProperty(name, this.state[name]);
              console.log('onBlur', this.state[name]);
            }}
          />
        </VehiclePropertyLoadable>
      </VBox>
    );
  }

  render() {
    return <Container>{this.renderEditableVehicleField(this.props.name, this.props.inputType)}</Container>;
  }
}

VehicleEditableFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleEditableField = compose(withConnect, withRouter)(VehicleEditableFieldComp);
